<template>
  <v-container class="container py-6 d-flex align-center justify-center flex-column" style="max-height: 90vh; overflow-y: auto;">
    <v-list>
      <v-list-item class="bg-light-gray"
          v-for="employ in employList" :key="employ.emplno">
        <EmployListItem :Employ="employ"/>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script setup lang="ts">
import EmployListItem from "@/components/EmployListItem.vue";

const props = defineProps({
  EmployList: { type: [], required: true }
});

const employList = props.EmployList;
</script>

<style scoped>

</style>